import React from "react"
import { graphql } from "gatsby"

import Layout from "../layouts/Layout"
import Seo from "../components/Seo"
import TextPage from "../components/TextPage"

export const pageQuery = graphql`
  query ContentfulTextPageQuery(
    $slug: String
    $language: String
    $originalPath: String
  ) {
    contentfulPageMetadata(
      node_locale: { eq: $language }
      pagePath: { eq: $originalPath }
    ) {
      ...PageMetadata
    }
    contentfulPage(slug: { eq: $slug }, node_locale: { eq: $language }) {
      slug
      node_locale
      browserTitle
      metaDescription
      metaKeywords
      header
      content {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`

const ContentfulTextPageTemplate = ({ data }) => {
  const pageMetadata = data.contentfulPageMetadata

  return (
    <Layout pageId={data.contentfulPage.slug}>
      <Seo
        {...pageMetadata}
        title={data.contentfulPage.browserTitle}
        description={
          data.contentfulPage.metaDescription &&
          data.contentfulPage.metaDescription
        }
        keywords={
          data.contentfulPage.metaKeywords && data.contentfulPage.metaKeywords
        }
      />
      <TextPage
        header={data.contentfulPage.header}
        content={
          <div
            dangerouslySetInnerHTML={{
              __html: data.contentfulPage.content.childMarkdownRemark.html,
            }}
          />
        }
      />
    </Layout>
  )
}

export default ContentfulTextPageTemplate
